// Setup (managers only, pinned at the rail's foot): the layout of the S1-17 manager screens —
// company settings (`/c/{slug}/setup` → General, routes/c.$slug.settings.tsx), the data-entry forms
// (`/c/{slug}/setup/entry/hours|numbers`) and the import wizard (`/c/{slug}/setup/import`).
// Navigation between them is the Setup sidebar (shell/sidebars/setup.tsx). COS-MODES: one page is
// every member's own card, "Who may direct my agents" (`/setup/agent-direction`): it opens for
// any member (the `chart` gate's audience), the rest of Setup stays managers only.
import { createRoute, Outlet, useRouterState } from "@tanstack/react-router";
import { NotFoundPage } from "../pages/status-pages";
import { MemberGate, ModeGate } from "../shell/mode-gate";
import { companyRoute } from "./c.$slug";

/** Setup pages every member opens (their own settings inside a company). */
const MEMBER_PAGES = /\/setup\/(agent-direction|voice)\/?$/;

export const setupRoute = createRoute({
  getParentRoute: () => companyRoute,
  path: "setup",
  component: function Setup() {
    const pathname = useRouterState({ select: (s) => s.location.pathname });
    if (MEMBER_PAGES.test(pathname))
      return (
        <MemberGate>
          <Outlet />
        </MemberGate>
      );
    return (
      <ModeGate modeKey="setup">
        <Outlet />
      </ModeGate>
    );
  },
});

/** Any other `/c/{slug}/{x}`: a mode that does not exist (yet). */
export const unknownModeRoute = createRoute({
  getParentRoute: () => companyRoute,
  path: "$mode",
  component: function UnknownMode() {
    const { mode } = unknownModeRoute.useParams();
    return <NotFoundPage message={`There is no "${mode}" mode.`} />;
  },
});
